import {
  ACTIVO_MATERIAS,
  ALERT_FORM_MATERIAS,
  ALERT_VIEW_MATERIAS,
  ALL_MATERIAS,
  LOADING_ALL_MATERIAS,
} from './OperadorasReducer';
import {
  deleteOperadorasService,
  allOperadorasService,
  oneOperadorasService,
  saveOperadorasService,
} from './OperadorasService';

export const allOperadorasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_MATERIAS, payload: true });
    const res = await allOperadorasService(params);
    if (res.status === 200) {
      dispatch({ type: ALL_MATERIAS, payload: res.data });
      dispatch({ type: LOADING_ALL_MATERIAS, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_MATERIAS, payload: false });
    return null;
  } catch (e) {
    alertOperadoras(dispatch, ALERT_VIEW_MATERIAS, {
      severity: 'warning',
      title: e.message,
    });
  }
};

export const saveOperadorasAction = async (dispatch, id, data, params) => {
  try {
    const res = await saveOperadorasService(id, data);
    const success = res.status >= 200 && res.status < 203;
    if (success) {
      await allOperadorasAction(dispatch, params);
      alertOperadoras(dispatch, ALERT_VIEW_MATERIAS, {
        severity: 'success',
        title: res.data.message,
      });
    } else {
      alertOperadoras(dispatch, ALERT_FORM_MATERIAS, {
        severity: 'error',
        title: 'Error al momento de registrar La materia',
      });
    }
    return success;
  } catch (e) {
    alertOperadoras(dispatch, ALERT_FORM_MATERIAS, {
      severity: 'error',
      title: e.response?.data.message ?? e.message,
    });
  }
};

export const setActivoOperadorasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_MATERIAS, payload: data });
};

export const oneOperadorasAction = async (dispatch, id) => {
  const res = await oneOperadorasService(id);
  if (res.status === 200) {
    await setActivoOperadorasAction(dispatch, res.data.data);
    return true;
  }
  return false;
};

export const alertOperadoras = (dispatch, type, payload) => {
  dispatch({ type, payload });
  setTimeout(() => {
    dispatch({ type, payload: null });
  }, 4500);
};

export const deleteOperadorasAction = async (
  dispatch,
  id,
  params,
  setLoadingDelete,
) => {
  try {
    setLoadingDelete(true);
    const res = await deleteOperadorasService(id);
    if (res.status === 200) {
      await setActivoOperadorasAction(dispatch, null);
      setLoadingDelete(false);
      await allOperadorasAction(dispatch, params);
      alertOperadoras(dispatch, ALERT_VIEW_MATERIAS, {
        severity: 'success',
        title: res.data.message ?? 'Materia eliminada exitosamente',
      });
      return true;
    }
    setLoadingDelete(false);
    alertOperadoras(dispatch, ALERT_VIEW_MATERIAS, {
      severity: 'error',
      title: res.data.message ?? 'Error al momento de eliminar La materia',
    });
    return false;
  } catch (e) {
    setLoadingDelete(false);
    alertOperadoras(dispatch, ALERT_VIEW_MATERIAS, {
      severity: 'error',
      title: e.response?.data.message ?? e.message,
    });
  }
};
